import { create } from 'zustand';

interface AudioPlayerStore {
  currentAudio: HTMLAudioElement | null;
  setCurrentAudio: (audio: HTMLAudioElement | null) => void;
}

export const useAudioPlayerStore = create<AudioPlayerStore>((set, get) => ({
  currentAudio: null,
  setCurrentAudio: (audio) => {
    const prev = get().currentAudio;
    if (prev && prev !== audio) {
      prev.pause();
    }
    set({ currentAudio: audio });
  },
}));
